import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_POLICIES_LIST,
  CREATE_POLICIES,
  EDIT_POLICIES_BY_ID,
  LOAD_POLICIES_BY_ID,
  DELETE_POLICIES,
} from './actions';
import { POLICIES_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  policiesListMeta: {},
  loadingPoliciesList: false,
  policiesList: [],
  loadingCurrentPolicies: false,
  currentPolicies: {},
  loadingCreatePolicies: false,
  loadingEditPoliciesById: false,
  loadingDeletePolicies: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(POLICIES_MODULE + LOAD_POLICIES_LIST, 'policiesList', 'loadingPoliciesList'),
  ...updateLoadParameterReducer(POLICIES_MODULE + LOAD_POLICIES_BY_ID, 'currentPolicies', 'loadingCurrentPolicies', {}),
  ...createOperationStateReducer(POLICIES_MODULE + CREATE_POLICIES, 'loadingCreatePolicies'),
  ...createOperationStateReducer(POLICIES_MODULE + EDIT_POLICIES_BY_ID, 'loadingEditPoliciesById'),
  ...createOperationStateReducer(POLICIES_MODULE + DELETE_POLICIES, 'loadingDeletePolicies'),
}, initialState);

export default reducer;

export const getPoliciesData = createSelector(
  [state => state[POLICIES_MODULE]],
  state => {
    const {
      policiesListMeta,
      loadingPoliciesList,
      policiesList,
      loadingCurrentPolicies,
      currentPolicies,
      loadingCreatePolicies,
      loadingEditPoliciesById,
      loadingDeletePolicies,
    } = state;
    return {
      policiesListMeta,
      loadingPoliciesList,
      policiesList,
      loadingCurrentPolicies,
      currentPolicies,
      loadingCreatePolicies,
      loadingEditPoliciesById,
      loadingDeletePolicies,
    };
  },
);
